import './basePath';
import './ckeditor';

window.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
